// extracted by mini-css-extract-plugin
export default {"Title":"SignUpTopicsStep_Title__q9kx4wAo","Tags":"SignUpTopicsStep_Tags__7DjtbWfP"};